export default "__VITE_PUBLIC_ASSET__f7eb4e20__"